<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="filtros-body">
        <div class="row">
          <!-- Datos del cliente -->
          <div class="col">
            <div class="row">
              <div class="col" style="max-width: 200px">
                <div class="md-form">
                  <mdb-select label="Docto. Ref." [options]="optionsDoctoReferencia" placeholder="Seleccionar Docto. Ref." [filterEnabled]="true" formControlName="doctoReferencia"> </mdb-select>
                  <span *ngIf="formHeader.get('doctoReferencia').invalid && (formHeader.get('doctoReferencia').dirty || formHeader.get('doctoReferencia').touched)">
                    <mdb-error *ngIf="formHeader.get('doctoReferencia').hasError('required') || formHeader.get('doctoReferencia').hasError('min')"> Ingrese docto. ref. </mdb-error>
                  </span>
                </div>
              </div>
              <div class="col" style="max-width: 200px">
                <div class="md-form">
                  <input value="" type="text" id="nroDoc" class="form-control" placeholder="000" required #nroDoc formControlName="nroDoc" onlyNumbers />
                  <label for="nroDoc">Nro. Doc.</label>

                  <span *ngIf="formHeader.get('nroDoc').invalid && (formHeader.get('nroDoc').dirty || formHeader.get('nroDoc').touched)">
                    <mdb-error *ngIf="formHeader.get('nroDoc').hasError('required')"> Ingrese nro. doc. </mdb-error>
                  </span>
                </div>
              </div>
              <div class="col" style="max-width: 60px">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect (click)="abrirModalSeleccionDocumento()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
              </div>
              <div class="col" style="max-width: 300px">
                <div class="md-form">
                  <mdb-select label="Tipo Nota Debito" [options]="optionsTipoNotaDebito" placeholder="Seleccionar Tipo Nota Debito" [filterEnabled]="true" formControlName="tipoNotaDebito">
                  </mdb-select>
                  <span *ngIf="formHeader.get('tipoNotaDebito').invalid && (formHeader.get('tipoNotaDebito').dirty || formHeader.get('tipoNotaDebito').touched)">
                    <mdb-error *ngIf="formHeader.get('tipoNotaDebito').hasError('required') || formHeader.get('tipoNotaDebito').hasError('min')"> Ingrese tipo nota débito </mdb-error>
                  </span>
                </div>
              </div>
              <div class="col" style="max-width: 300px">
                <div class="md-form justify-content-end filtros-footer" >
                  <mdb-date-picker #datePicker [inline]="true" name="fechaInicio" [placeholder]="'Fecha Emisión'" required formControlName="fechaDocumento"> </mdb-date-picker>
                  <div *ngIf="formHeader.get('fechaDocumento').invalid && (formHeader.get('fechaDocumento').dirty || formHeader.get('fechaDocumento').touched)">
                    <mdb-error *ngIf="formHeader.get('fechaDocumento').hasError('required')">Ingrese fecha </mdb-error>
                  </div>
                </div>
              </div>
            </div>



            <!-- <div class="row align-items-center">
              <div class="col">
                <div class="md-form">
                  <mdb-select label="Vendedor" [options]="optionsVendedor" placeholder="Seleccionar vendedor"
                    [filterEnabled]="true" formControlName="vendedor"></mdb-select>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <!-- FIN/ FILA #2 -->
      </div>
    </div>
  </div>

  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col dato" style="max-width: 120px;">
              <Strong class="title">RUT de cliente</Strong>
              <span class="value" *ngIf="dataCabecera; else dummyTxt">
                {{ dataCabecera.cabecera.additionalInfo.cliente_proveedor_rut_completo | rut }}
              </span>
              <ng-template #dummyTxt>
                <div class="dummyTxt"></div>
              </ng-template>
            </div>

            <div class="col dato" style="max-width: 300px;">
              <Strong class="title">Nombre de cliente</Strong>
              <span class="value" *ngIf="dataCabecera; else dummyTxt">
                {{ dataCabecera.cabecera.cliente_nombre }}
              </span>
              <ng-template #dummyTxt>
                <div class="dummyTxt"></div>
              </ng-template>
            </div>
            <!-- <div class="col dato" style="max-width: 200px;">
              <Strong class="title">Nro. Docto.</Strong>
              <span class="value" *ngIf="dataCabecera; else dummyTxt">{{ dataCabecera.cabecera.folio }}</span>
              <ng-template #dummyTxt>
                <div class="dummyTxt"></div>
              </ng-template>
            </div>
            <div class="col dato" style="max-width: 200px;">
              <Strong class="title">Tipo. Docto.</Strong>
              <span class="value" *ngIf="dataCabecera; else dummyTxt">{{ dataCabecera.cabecera.tipo_dte_nombre }}</span>
              <ng-template #dummyTxt>
                <div class="dummyTxt"></div>
              </ng-template>
            </div> -->
            <div class="col dato" style="max-width: 110px;">
              <Strong class="title">Fecha Docto.</Strong>
              <span class="value" *ngIf="dataCabecera; else dummyTxt">{{ dataCabecera.cabecera.fecha_emision | date }}</span>
              <ng-template #dummyTxt>
                <div class="dummyTxt"></div>
              </ng-template>
            </div>
            <div class="col d-flex align-items-center" style="max-width: 140px;">
              <mdb-checkbox formControlName="rebajaStock" [(ngModel)]="rebajaStockDisable"
                [disabled]="desactivaRebajaStockAndAplicacion">Rebaja
                stock</mdb-checkbox>
            </div>
            <div class="col d-flex align-items-center" style="visibility: hidden;">
              <!-- Material inline 1 -->
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="rbTipoCorreCorreccionMontoDevolucion"
                  [value]="TIPO_CORRECCION_MONTO_DEVOLUCION" formControlName="tipoCorreccionMonto" mdbInput>
                <label class="form-check-label" for="rbTipoCorreCorreccionMontoDevolucion">Devolución</label>
              </div>

              <!-- Material inline 2 -->
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="rbTipoCorreCorreccionMontoCorreccion"
                  [value]="TIPO_CORRECCION_MONTO_CORRECCION" formControlName="tipoCorreccionMonto" mdbInput>
                <label class="form-check-label" for="rbTipoCorreCorreccionMontoCorreccion">Corrección de
                  monto</label>
              </div>
            </div>
          </div>
        </div>

      </div>


      <!-- <div class="row ">
                    <div class="col">
                      <div class="md-form">
                        <mdb-select label="Sucursal" [options]="optionsSucursal" placeholder="Seleccionar Sucursal"
                          [filterEnabled]="true" formControlName="sucursal"></mdb-select>
                      </div>
                    </div>
                    <div class="col">
                      <div class="md-form">
                        <input value="" type="text" id="dire" class="form-control" placeholder="Dirección" required #dire />
                        <label for="dire">Dirección</label>
                      </div>
                    </div>
                    <div class="col">
                      <div class="md-form">
                        <input value="" type="text" id="comuna" class="form-control" placeholder="Comuna" required #comuna />
                        <label for="comuna">Comuna</label>
                      </div>
                    </div>
                    <div class="col">
                      <div class="md-form">
                        <input value="" type="text" id="provincia" class="form-control" placeholder="Provincia" required
                          #provincia />
                        <label for="provincia">Provincia</label>
                      </div>
                    </div>
                  </div> -->

      <div class="row">
        <div class="col dato" >
          <Strong class="title">Sucursal</Strong>
          <span class="value" *ngIf="dataCabecera; else dummyTxt">{{ dataCabecera.cabecera.direccion_nombre }}</span>
          <ng-template #dummyTxt>
            <div class="dummyTxt"></div>
          </ng-template>
        </div>
        <div class="col dato">
          <Strong class="title">Dirección</Strong>
          <span class="value" *ngIf="dataCabecera; else dummyTxt">
            {{ dataCabecera.cabecera.direccion_completa_facturacion }}
          </span>
          <ng-template #dummyTxt>
            <div class="dummyTxt"></div>
          </ng-template>
        </div>
        <div class="col dato" style="max-width: 120px;">
          <Strong class="title">Comuna</Strong>
          <span class="value" *ngIf="dataCabecera; else dummyTxt">{{ dataCabecera.cabecera.comuna_facturacion }}</span>
          <ng-template #dummyTxt>
            <div class="dummyTxt"></div>
          </ng-template>
        </div>
        <div class="col dato" style="max-width: 120px;">
          <Strong class="title">Provincia</Strong>
          <span class="value" *ngIf="dataCabecera; else dummyTxt">{{ dataCabecera.cabecera.provincia_facturacion }}</span>
          <ng-template #dummyTxt>
            <div class="dummyTxt"></div>
          </ng-template>
        </div>
        <div class="col dato">
          <Strong class="title">Vendedor</Strong>
          <span class="value" *ngIf="dataCabecera; else dummyTxt">{{ dataCabecera.cabecera.vendedor_nombre }}</span>
          <ng-template #dummyTxt>
            <div class="dummyTxt"></div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</form>

<app-modal-seleccion-documento [tipo_dte_codigo]="doctoReferencia" [es_nd]="true" (onSelect)="onDocumentoSeleccionado($event)" (onNotFound)="onNotFoundDocumento()"> </app-modal-seleccion-documento>
